module.exports = __webpack_public_path__ + "static/media/4.494a9fe5.png";